// extracted by mini-css-extract-plugin
export var cmtFancyText = "styles-module--cmt-fancy-text--f9a33";
export var cmtFancyText__word = "styles-module--cmt-fancy-text__word--a83fe";